import { useFlashStore } from "~~/store/flashStore"

export default defineNuxtPlugin(() => {
    const flash = useFlashStore()

    return {
        provide: {
            flash: (message, type) => {
                flash.show(message, type)
            },
        }
    }
})
